import React from "react";
import { Button } from "antd-mobile";
import storageUtil from "../../utils/storageUtil";
import { useNavigate } from "react-router-dom";

const MineScreen: React.FC = React.memo((props) => {
  const navigation = useNavigate();

  const logout = () => {
    storageUtil.removeItem("CREDENTIAL");
    navigation("/");
  };

  return (
    <div>
      <Button block color="primary" size="large" onClick={logout}>
        退出登录
      </Button>
    </div>
  );
});

export default MineScreen;
